import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("button", {
    class: "manual-button__button",
    type: "button",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('click')), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}